<template>
  <v-card
    variant="outlined"
    class="d-flex align-center"
    :color="isActive ? 'blue-darken-3' : 'balck'"
    :style="{
      minHeight: '68px',
      borderWidth: '2px',
      background: isActive ? '#e6f1fb' : 'white',
      borderColor: isActive ? '#185fa5' : '#e8e8ed',
    }">
    <v-card-text>
      <div class="d-flex ga-3">
        <v-radio style="max-width: 40px" :value="value"></v-radio>
        <div>
          <div class="font-weight-bold font-size-16">
            {{ title }}
          </div>
          <div v-if="subtitle" class="text-disabled">
            {{ subtitle }}
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineOptions({
  name: 'RadioCard',
})

defineProps<{
  value: string | number
  isActive: boolean
  title: string
  subtitle?: string
}>()
</script>
